<template>
  <section class="text-fg-g-primary">
    <div
      :style="
        !isCheckoutDesktopFlow
          ? { 'min-height': '100vh' }
          : { 'min-height': `calc(100vh - ${height}px)` }
      "
      :class="[isCheckoutDesktopFlow ? 'flex justify-between items-start' : '']"
    >
      <GuestHeader v-if="(header || isOrderDetailsPage) && !isCheckoutDesktopFlow" />
      <router-view
        :class="isCheckoutDesktopFlow ? 'py-16 px-12 w-full shrink-[20]' : 'min-h-screen'"
      />
      <CheckoutDesktopDetailSidebar v-if="isCheckoutDesktopFlow" />
    </div>
    <FooterComponent v-if="checkoutStore.performance === null" />
  </section>
</template>

<script lang="ts">
import { breakpointsTailwind, useBreakpoints, useResizeObserver } from '@vueuse/core'
import { mapStores } from 'pinia'
import { defineComponent } from 'vue'
import 'vue-advanced-cropper/dist/style.css'

import CheckoutDesktopDetailSidebar from '@/components/CheckoutDesktopDetailSidebar.vue'
import FooterComponent from '@/components/FooterComponent.vue'
import GuestHeader from '@/components/guest/GuestHeader.vue'
import { useCheckoutStore } from '@/stores/checkout'
import { useSettingStore } from '@/stores/setting'

export default defineComponent({
  name: 'App',
  components: {
    CheckoutDesktopDetailSidebar,
    FooterComponent,
    GuestHeader,
  },
  data() {
    return {
      height: 200,
    }
  },
  mounted() {
    useResizeObserver(this.footer, this.onResize)
    document.body.classList.add('guest-ui')
    document.documentElement.classList.add('light')
  },
  computed: {
    ...mapStores(useSettingStore, useCheckoutStore),
    header(): boolean {
      return !!this.$route.meta?.header
    },
    isOrderDetailsPage(): boolean {
      return this.$route.name === 'order-details'
    },
    footer() {
      return document.querySelector('footer')
    },
    isLargeScreen(): boolean {
      return useBreakpoints(breakpointsTailwind).lg.value
    },
    isCheckoutDesktopFlow(): boolean {
      return (
        this.checkoutStore.performance !== null &&
        this.isLargeScreen &&
        this.$route.name !== 'setShow' &&
        this.$route.name !== 'showDetails' &&
        this.$route.name !== 'calendar' &&
        this.$route.name !== 'order-details'
      )
    },
  },
  watch: {
    isCheckoutDesktopFlow: {
      immediate: true,
      handler(value: boolean) {
        this.checkoutStore.setIsDesktopFlow(value)
      },
    },
  },
  methods: {
    onResize() {
      this.height = this.footer?.clientHeight || 200
    },
  },
})
</script>
